"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBentoBoxChainId = exports.BENTOBOX_ADDRESS = exports.BENTOBOX_SUPPORTED_CHAIN_IDS = void 0;
const chain_1 = require("@sushiswap/chain");
exports.BENTOBOX_SUPPORTED_CHAIN_IDS = [
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.ARBITRUM_NOVA,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BOBA,
    chain_1.ChainId.BOBA_AVAX,
    chain_1.ChainId.BOBA_BNB,
    chain_1.ChainId.BSC,
    chain_1.ChainId.BTTC,
    chain_1.ChainId.CELO,
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.FUSE,
    chain_1.ChainId.GNOSIS,
    chain_1.ChainId.HARMONY,
    chain_1.ChainId.HECO,
    chain_1.ChainId.KAVA,
    chain_1.ChainId.METIS,
    chain_1.ChainId.MOONBEAM,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.HAQQ,
    chain_1.ChainId.CORE,
    chain_1.ChainId.THUNDERCORE
];
exports.BENTOBOX_ADDRESS = {
    [chain_1.ChainId.ARBITRUM]: '0x74c764D41B77DBbb4fe771daB1939B00b146894A',
    [chain_1.ChainId.ARBITRUM_NOVA]: '0xbE811A0D44E2553d25d11CB8DC0d3F0D0E6430E6',
    [chain_1.ChainId.AVALANCHE]: '0x0711B6026068f736bae6B213031fCE978D48E026',
    [chain_1.ChainId.BOBA]: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
    [chain_1.ChainId.BOBA_AVAX]: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
    [chain_1.ChainId.BOBA_BNB]: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
    [chain_1.ChainId.BSC]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
    [chain_1.ChainId.BTTC]: '0x8dacffa7F69Ce572992132697252E16254225D38',
    [chain_1.ChainId.CELO]: '0x0711B6026068f736bae6B213031fCE978D48E026',
    [chain_1.ChainId.ETHEREUM]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
    [chain_1.ChainId.FANTOM]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
    [chain_1.ChainId.FUSE]: '0x0BE808376Ecb75a5CF9bB6D237d16cd37893d904',
    [chain_1.ChainId.GNOSIS]: '0xE2d7F5dd869Fc7c126D21b13a9080e75a4bDb324',
    [chain_1.ChainId.HARMONY]: '0x6b2A3FF504798886862Ca5ce501e080947A506A2',
    [chain_1.ChainId.HECO]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
    [chain_1.ChainId.KAVA]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    [chain_1.ChainId.METIS]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    [chain_1.ChainId.MOONBEAM]: '0x80C7DD17B01855a6D2347444a0FCC36136a314de',
    [chain_1.ChainId.MOONRIVER]: '0x145d82bCa93cCa2AE057D1c6f26245d1b9522E6F',
    [chain_1.ChainId.OPTIMISM]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    [chain_1.ChainId.POLYGON]: '0x0319000133d3AdA02600f0875d2cf03D442C3367',
    [chain_1.ChainId.HAQQ]: '0xCdBCd51a5E8728E0AF4895ce5771b7d17fF71959',
    [chain_1.ChainId.CORE]: '0x1400feFD6F9b897970f00Df6237Ff2B8b27Dc82C',
    [chain_1.ChainId.THUNDERCORE]: '0xe43ca1Dee3F0fc1e2df73A0745674545F11A59F5',
};
const isBentoBoxChainId = (chainId) => exports.BENTOBOX_SUPPORTED_CHAIN_IDS.includes(chainId);
exports.isBentoBoxChainId = isBentoBoxChainId;
//# sourceMappingURL=index.js.map